import { useState } from 'react'

import ReactMarkdown from 'react-markdown'

import { ChevronFlip, FormattedDate } from '@subaio/components'
import { cases, renderIdentifier } from '@subaio/utils'

import { components } from 'components/DefaultMdxComponents'

import { Container } from './Container'
import { Content } from './Content'
import { DeprecatedType, getDeprecatedProperties } from './getDeprecatedProperties'
import { Header } from './Header'

type Props = {
	propertyDescription: string
	fieldName: string
}

export const DeprecatedAlertBox = ({ propertyDescription, fieldName }: Props) => {
	const { type, markedAt, removedWhen, movedTo, description } = getDeprecatedProperties(propertyDescription, fieldName)
	const [isOpen, setIsOpen] = useState(false)

	return (
		<Container>
			<Header isOpen={isOpen} onClick={() => setIsOpen((isOpen) => !isOpen)}>
				<ChevronFlip isActive={isOpen} />
				<span>Marked as deprecated - {renderIdentifier(type)}</span>
				<span>
					- <FormattedDate value={removedWhen} />
				</span>
			</Header>
			{isOpen ? (
				<Content>
					<p>
						{cases(type, {
							[DeprecatedType.Moved]: 'This item has been moved to a new location and will be deleted in the future.',
							[DeprecatedType.Deleted]: 'This item will be deleted in the future.',
						})}
					</p>
					{markedAt && (
						<p>
							Deprecated since <FormattedDate value={markedAt} /> and we cannot guarantee its existence after{' '}
							<FormattedDate value={removedWhen} />. It is possible the property will be removed before this date if all
							known consumers of the property have already addressed this.
						</p>
					)}
					{description && <ReactMarkdown components={components}>{description}</ReactMarkdown>}
					{movedTo ? <ReactMarkdown components={components}>{`New location: ${movedTo}`}</ReactMarkdown> : null}
				</Content>
			) : null}
		</Container>
	)
}
